/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_Consumer_NameInputs */

const vi_order_form_invoice_buyer_consumer_name = /** @type {(inputs: Order_Form_Invoice_Buyer_Consumer_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Họ tên người mua`)
};

/**

* @param {Order_Form_Invoice_Buyer_Consumer_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_consumer_name = /** @type {((inputs?: Order_Form_Invoice_Buyer_Consumer_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_Consumer_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_consumer_name(inputs)
});